import { render, staticRenderFns } from "./formLabel.vue?vue&type=template&id=04b56666&scoped=true"
import script from "./formLabel.vue?vue&type=script&lang=js"
export * from "./formLabel.vue?vue&type=script&lang=js"
import style0 from "./formLabel.vue?vue&type=style&index=0&id=04b56666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b56666",
  null
  
)

export default component.exports